import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { DonleeFechtAPI } from '../../api/Donlee';
import ErrorAlert from '../Alerts/ErrorAlert';
import { RenderIf } from '../utils/RenderIf';
 import './ModuleTips.css'
import Accordion from 'react-bootstrap/Accordion';

function ModuleTips({ invoiceTips, setInvoiceTips, recomendationTips, setEventHandler }) {
    const [showModal, setShowModal] = useState(false)
    let token = localStorage.getItem('x-access-machine-token');

    const handlerInputText = (value) => {
        let input = document.getElementById('inputTips')
        input.value = value
    }

    const handleChange = (e) => {

        if (e.target.value == "") {
            setInvoiceTips(0.00)
        } else {
            setInvoiceTips(parseFloat(e.target.value))
        }

        setEventHandler(1)

    }



    return (
        <>

            <div className="sp-tips">

                {/* Encabezado: total propina + input monto */}
                <div className="sp-tips__head">
                    <div className="sp-tips__amount">
                        <span className="sp-tips__amount-label">Propina</span>
                        <span className="sp-tips__amount-val" translate="no">${invoiceTips}</span>
                    </div>
                    <div className="sp-tips__inputwrap">
                        <span className="sp-tips__inputcur">$</span>
                        <input
                            id="inputTips"
                            type="number"
                            step="0.01"
                            className="sp-tips__input"
                            placeholder="Ingrese un monto"
                            onChange={(e) => handleChange(e)}
                        />
                    </div>
                </div>

                {/* Opciones recomendadas como radio buttons */}
                <div className="sp-tips__body">
                    <span className="sp-tips__sublabel">Propina recomendada</span>
                    <div className="sp-tips__grid">

                        {/* 0% */}
                        <label className="sp-tips__opt">
                            <input
                                type="radio"
                                name="tip_option"
                                className="sp-tips__radio"
                                checked={Number(invoiceTips) === 0}
                                onChange={() => (handlerInputText(0.00), setInvoiceTips(0.00), setEventHandler(1))}
                            />
                            <span className="sp-tips__card">
                                <span className="sp-tips__tick" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                                </span>
                                <span className="sp-tips__rate">0%</span>
                                <span className="sp-tips__val" translate="no">$0.00</span>
                            </span>
                        </label>

                        {/* Recomendadas */}
                        {recomendationTips.map((tip, idx) => (
                            <label className="sp-tips__opt" key={idx}>
                                <input
                                    type="radio"
                                    name="tip_option"
                                    className="sp-tips__radio"
                                    checked={Number(invoiceTips) === Number(tip.value)}
                                    onChange={() => (handlerInputText(tip.value), setInvoiceTips(tip.value), setEventHandler(1))}
                                />
                                <span className="sp-tips__card">
                                    <span className="sp-tips__tick" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                                    </span>
                                    <span className="sp-tips__rate">{tip.rate}</span>
                                    <span className="sp-tips__val" translate="no">${tip.value}</span>
                                </span>
                            </label>
                        ))}
                    </div>
                </div>
            </div>

        </>
    )
}

export default ModuleTips